import * as z from "zod/mini";
import { APPLE_PAY_BUTTON_DIMENSION_PATTERN } from "@connect/component-library/components/apple-pay-button";

// Shared parsing helpers for the button-settings query params (Apple Pay, card,
// Google Pay). Each frame's settings module layers its own enums on top.

export const MAX_JSON_LENGTH = 4096;

/** Parses a settings query param (JSON); guards against oversized or invalid input. */
export function parseSettingsJson(raw: string | null | undefined): unknown {
  if (!raw || raw.length > MAX_JSON_LENGTH) {
    return undefined;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}

/** An optional px dimension; a bad value falls back to undefined without failing its siblings. */
export const dimensionSchema = z.catch(
  z.optional(z.string().check(z.regex(APPLE_PAY_BUTTON_DIMENSION_PATTERN))),
  undefined,
);

/** Appends `px` when a bare number is given. */
export function normalizeDimension(value: string | undefined): string | undefined {
  if (!value) {
    return undefined;
  }
  return value.endsWith("px") ? value : `${value}px`;
}
